import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { NavBar } from '../../components/navbar'
import { Footer } from '../../components/footer'
import { SearchInput } from '../../components/input'
import { FaqCard } from '../../components/faqcard'
import { colors } from '../../colors'
import { Button } from '../../components/button'
import { HeroSection, BodyContainer, InnerBodyContainer,  } from '../advancedsearch'

// getSystemFaqs
import { useSelector, useDispatch } from 'react-redux'
import {  getFaqs,  } from '../features/faqs/faqSlice'

import { getFaqCategory } from '../features/faqcategory/faqcategorySlice'

const Faqs = () => {

    const [toggleState, setToggleState] = useState(1);
    const toggleTab = (index) => {
        setToggleState(index);
        
    }

    const dispatch = useDispatch()
    const { faqs, faqCreatedStatus } = useSelector(state => state.faqs);
    const { faqCategory, faqCategoryStatus} = useSelector(state => state.faqCategory);


    useEffect(() => {
          
        dispatch(getFaqCategory());

    }, [faqCategoryStatus]);


    useEffect(() => {
          
        dispatch(getFaqs());

    }, [faqCreatedStatus]);

  return (
    <Container>
        <NavBar />

        <HeroSection>
            <div>
                <h2>National Virtual Library Search</h2>
                <p>Find information and abstracts of more than 100,000 collection resources, including over 50,000 online materials</p>
                <SearchInput />
            </div>
        </HeroSection>

        <BodyCont>
            <TabsBody>
                <TabsHeader>
                    <ul>
                        <li /* A function that is being called when the li is clicked. */
                        onClick={ () => toggleTab(1)} >Browse FAQs</li>
                        <li onClick={ () => toggleTab(2)}>Find by categories</li>
                        <li onClick={ () => toggleTab(3)}>Ask a librarian</li>
                    </ul>
                </TabsHeader>
                
                <TabsContent>
                    {
                    
                    toggleState === 1 
                    ?
                    
                        <> 
                            {
                                faqs.length > 0 ? (
                                    faqs.map((faq) => {

                                        return(
                                            <FaqCard key={faq.faqId} faq={faq}
                                            question={faq.faqQuestion} 
                                            answer={faq.faqAnswer} />
                                            
                                            
                                        )
                                    }

                                )) : 
                                
                                <>
                                    <FaqCard question="What is the National Virtual Library?" answer="The National Virtual Library is a collection of digital resources that are available to the public. The library is a repository of materials that are essential to the understanding of the natural and social sciences, and to the study of the arts." category="General" />
                                    <FaqCard question={'Do I need to login to access resources?'} answer={'No, you can access any information you want, no need to login.'} />
                                    <FaqCard question={'How do I search for resources?'} answer={'You can search for resources by title, author, or keyword. You can also search by category.'} />

                                </>
                            }
                        </>
                        
                        
                    :(toggleState === 2
                    ? 

                    <> 
                            {
                                faqCategory.length > 0 ? (
                                    faqs.map((faqCategory) => {

                                        return(
                                            <FaqCard key={faqCategory.faqId} faqCategory={faqCategory}
                                            question={faqCategory.faqCategoryName} 
                                            
                                            />
                                            
                                            
                                        )
                                    }

                                )) : 
                                
                                <>
                                    <h4>You have not created any FAQ categories</h4>
                                </>
                            }
                        </>
                        


                    // <>
                    // <FaqCard question={'General (5)'} answer={'You can search for resources by title, author, or keyword. You can also search by category.'} />
                    // <FaqCard question={'Nigeriana (201)'} answer={'You can search for resources by title, author, or keyword. You can also search by category.'} />
                    // <FaqCard question={'Education (10,235)'} answer={'You can search for resources by title, author, or keyword. You can also search by category.'} />
                    // </>
                    :(toggleState === 3 ?
                        <AskLibrarian>
                        
                            <p>Use this form to ask a general question </p>
                            <h3>Your Contact Info</h3>
                            <hr />

                            <form>
                                <div>
                                    <label htmlFor='name' >Name <span>*</span> </label>
                                    <input name='name' id='name' type="text" required />
                                </div>

                                <div>
                                    <label htmlFor='email' >Email <span>*</span></label>
                                    <input name='email' id='email' type="email" required />
                                </div>

                                <h3>Your Question</h3>
                                <hr />
                                <h5>Please provide as much details as possible, including information on resources you have already consulted. </h5>

                                <div>
                                    <label htmlFor='text' >Question <span>*</span></label>
                                    <textarea name="text" id="text" cols="30" rows="10"></textarea>
                                </div>
                                <h5>Field marked with  <span>*</span> are required</h5>
                                <Button filled bgColor={'#2A870E'} text='Ask Your Question' noIcon />
                            </form>



                        </AskLibrarian>: ''))
                    
                    }
                    
                </TabsContent>

            </TabsBody>
        </BodyCont>

<Footer />
    </Container>
  )
}

const Container = styled.section`
    width: 100%;
    margin: 0 auto;
`
const BodyCont = styled.div`
    padding-top: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 50%;
    max-width: 1250px;
    margin: 0 auto;

    @media screen and (max-width: 600px){
        width: 90%;
    }
`

const TabsBody = styled.section`
    display: flex;
    flex-direction: column;
    padding-bottom: 70px;
    max-width: 1250px;

    @media screen and (max-width: 600px){
          width: 100%;
        }
    `
const TabsHeader = styled.div`
    width: 100%;
    /* max-width: 1250px; */
    background-color: #EAECF0;
    border-radius: 4px;

    & > ul{
        width: 100%;
        display: flex;
        /* justify-content: space-between; */
        flex-direction: row;
        

        & li{
            text-align: center;
            padding: 15px 65px;
            width: max-content;
            font-weight: 600;
            font-size: 1.6rem;
            color: #000;
            flex: 1;

            & :active{
                color: #1c991c !important;
            }

            & :hover{
                color: #1c991c !important;
            }
            /* border: 1px solid #D0D5DD; */
            cursor: pointer;
            /* background-color: {(toggleTab === 1 ? '#red' : '#fff') }; */

            @media screen and  (max-width: 600px) {
                font-size: 1.4rem;
                padding: 15px 0px;
            }
        }
    }
`
const TabsContent = styled.div`
    max-width: 1250px;
    
    width: 100%;
`

const AskLibrarian = styled.div`
    width: 80%;

    @media screen and (max-width: 600px){
          padding: 0 20px;
        }

    & label{
        font-size: 14px;
        margin-bottom: 10px;
        margin-top: 30px;
        align-self: flex-start;
        font-weight: 500;

        & span{
            color: #F04438;
        }
    }

    & span{
            color: #F04438;
        }

    & input{
        border: 2px solid #D0D5DD;
        border-radius: 4px;
        height: 32px;
        padding: 0 10px;
        background-color: #fff;
    }


    & p{
        font-size: 16px;
        padding: 20px 0;
        color: #667085;

        @media screen and (max-width: 600px){
          padding-bottom: 0px;
        }
    }

    &  div{
        width: 100%;
        display: flex;
        flex-direction: column;

        & textarea{
            height: 78px;
            background-color: #fff;
            border: 2px solid #D0D5DD;
            border-radius: 4px;
            padding: 10px;
        }
    }

    & h5{
        font-size: 16px;
        font-weight: 400;
        padding-top: 16px;
        color: #667085;
    }

    & button{

        margin-top: 24px;
        & span{
            color: inherit;
        }
    }

    & h3{
        margin-top: 30px;

        @media screen and (max-width: 600px){
          font-size: 1.5rem;
          font-weight: 600;
        }
    }
`

export {Faqs}